import { render, staticRenderFns } from "./Payment.Detail.vue?vue&type=template&id=c8649660&"
import script from "./Payment.Detail.vue?vue&type=script&lang=js&"
export * from "./Payment.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports